module.exports = __webpack_public_path__ + "img/IMG_Phone_3.53a677f0.jpg";